import { useState } from 'react';

/** Hide optional / advanced fields until the user opens them — keeps the main view short. */
export default function AdminCollapsible({ title, hint, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`admin-collapse${open ? ' admin-collapse--open' : ''}`}>
      <button
        type="button"
        className="admin-collapse__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span className="admin-collapse__title">{title}</span>
        {hint ? <span className="admin-collapse__hint">{hint}</span> : null}
        <span className="admin-collapse__icon" aria-hidden>
          {open ? '▾' : '▸'}
        </span>
      </button>
      {open ? <div className="admin-collapse__body">{children}</div> : null}
    </div>
  );
}
